const endPoints = {
    ADMIN_lOGIN: '/login',
    // GET_LIST_OF_BUILDINGS: 'http://3.7.82.174:4446/api/v1/customers/66aca68db180b45b2dfe62a3/buildings',
};
export { endPoints };
